let active = 0;
const listeners = new Set<(loading: boolean) => void>();

function notify() {
  const loading = active > 0;
  listeners.forEach((fn) => fn(loading));
}

export function startLoading() {
  active++;
  notify();
}

export function stopLoading() {
  active--;
  notify();
}

export function onLoadingChange(fn: (loading: boolean) => void) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
